module.exports = __webpack_public_path__ + "static/media/PlutoLight.5d4325c2.ttf";